export default __webpack_public_path__ + "static/stepuplogo-8e8d034a37cd5befa4b09f8aeb9c97dd.png";